import React, { useEffect, useState } from 'react'
import Layout from '../components/layout/Layout'
import { Box, Tabs, Tab } from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router'
import GenAI from '../components/premium_feature/GenAI'
import LDCAndChallanPdfReader from '../components/premium_feature/LDCAndChallanPdfReader'
import SSR from '../components/premium_feature/SSR'
import TabPanel from "../components/common/TabPanel"

const PremiumFeature = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [activeTab, setActiveTab] = useState('genAI')
  const navigate = useNavigate()
  const tabs = [
    { key: 'genAI', label: 'Gen AI', component: <GenAI /> },
    {
      key: 'ldc',
      label: 'LDC & Challan Pdf Reader',
      component: <LDCAndChallanPdfReader />,
    },
    { key: 'ssr', label: 'SSR', component: <SSR /> },
  ]

  useEffect(() => {
    const step = searchParams.get('step')
    if (step && tabs.some(t => t.key === step)) {
      setActiveTab(step)
    }
  }, [searchParams])

  const handleTabChange = (event, newIndex) => {
    const newKey = tabs[newIndex].key
    setActiveTab(newKey)
    setSearchParams({ step: newKey })
    navigate('/premium-features?step=' + newKey, { replace: true })
  }

  return (
    <Layout>
      <Box sx={{ width: '100%' }}>
        {/* Tab Navigation */}
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'var(--border-strong)',
          }}
        >
          <Tabs
            value={tabs.findIndex(t => t.key === activeTab)}
            onChange={handleTabChange}
            aria-label="admin dashboard tabs"
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 400,
                fontSize: '14px',
                padding: '12px 16px',
                color: 'var(--forbrand-secondary)',
                '&.Mui-selected': {
                  color: 'var(--forbrand-primary)',
                  fontWeight: 700,
                },
              },
              '& .MuiTabs-indicator': {
                backgroundColor: 'var(--forbrand-color)',
                height: 2,
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab
                key={tab.key}
                label={tab.label}
                id={`admin-tab-${index}`}
                aria-controls={`admin-tabpanel-${index}`}
              />
            ))}
          </Tabs>
        </Box>

        {/* Tab Content */}
        {tabs.map((tab, index) => (
          <TabPanel
            key={tab.key}
            value={tabs.findIndex(t => t.key === activeTab)}
            index={index}
          >
            {tab.component}
          </TabPanel>
        ))}
      </Box>
    </Layout>
  )
}

export default PremiumFeature
